import api from './axios.js'

export const getMain = () => {
	return api.get('/content/pages/main/')
}
